<template>
    <div class="container">

        <CommonBreadcrumb class="bread_block" />  

        <CyoSteps :page="'setting'" :moduleSubType="moduleSubType" />

        <CommonTitleDescription :title="tags.seo.value.page_title" :description="tags.seo.value.page_description" :total="resultCount" />
        <div class="min_height">
            <CommonJewelryFilter :viewType="viewType" @changeViewType="changeViewType" />

            <div class="loader_box_mod" v-show="showSkeleton">
                <img width="200" loading="lazy" height="200" alt="loader" src="~/assets/assets/loader.svg">
            </div>

            <CommonNoResultFound class="mt-1 pt-1" v-if="displayNoResults" :type="'no_result'" />
            <CommonNoResultFound class="mt-1 pt-1" v-if="hasError" :type="'client_network_error'" />

            <!-- <TransitionGroup appear v-show="!showSkeleton"  name="prod_box_animation" tag="div" class="row listing-container-min-height"> -->
            <div class="row listing-container-min-height" v-show="!showSkeleton">
                <CyoSettingProductBox 
                    v-for="data in results" 
                    :key="data.uniqueKey" 
                    :viewType="viewType"
                    :style="{ transitionDelay: `${data.transitionDelayKey * 30}ms` }"
                    :type="'cyor'" 
                    :data="data"  
                    @openQuickView="openQuickView"
                />
                
                <CyoSettingQuickViewSetting 
                    class="for_mobile" 
                    :data="quickViewProduct" 
                    :openQuickSettingView="openQuickSettingView" 
                    @handleCloseQuickView="closeQuickView"/>
            </div>
            <!-- </TransitionGroup> -->


            <div class="loader_box_mod" v-show="showMoreSkeleton">
                <img width="200" loading="lazy" height="200" alt="loader" src="~/assets/assets/loader.svg">
            </div>

            <div v-if="getSettingListingNextPageUrl" class="text-center mx-auto my-5 more_data_box">
                <div class="show_more_btn" @click="showMore()">SHOW MORE</div>
            </div>
        </div>


        <CommonH2TitleDescription :title="tags.seo.value.h2_title" :description="tags.seo.value.h2_description" /> 

        <FaqDynamicFaq class="mt-4 pt-4" />

        <CyoPopup :module="moduleSubType" />
    </div>
</template>

<script setup>
    import { cyolistStore }  from '@/stores/cyolist/cyolist';
    import { useNuxtApp } from '#app';
    import { useSeo } from '~/composables/seo/setMetaTags';

    const quickViewProduct= ref(null)
    const openQuickSettingView = ref(false)

    const store = cyolistStore();
    const route = useRoute();
    const { $choosesettingGtag } = useNuxtApp()
    const router = useRouter();
    const tags = useSeo();


    const moduleType = route.meta.moduleType
    const moduleSubType = route.meta.moduleSubType 

    const viewType = ref('grid')
    const nuxtApp = useNuxtApp()

    const fAttributes = [
        {
            name:'metal',
            label:'Metal',
            urlLabel:'Metal',
            type:'select', 
            hasIcon:true,
            iconBasePath:'/assets/metals/',
            iconType:'.png',
            singleSelect:true,
            default:null,
            isOpen:false
        },
        {
            name:'style',
            label:'Style',
            urlLabel:'Style',
            type:'select', 
            hasIcon:false,
            iconBasePath:'/assets/metals/',
            iconType:'.png',
            singleSelect:false,
            default:null,
            isOpen:false
        },
        {
            name:'shape',
            label:'shape',
            urlLabel:'Shape',
            type:'select', 
            displaySelected:false, 
            singleSelect:true,
            default:null,
            isOpen:false,
            config:{}
        },
        {
            name:'sort',
            label:'Sort',
            urlLabel:'Sort',
            type:'select', 
            displaySelected:true, 
            hasIcon:false,
            iconBasePath:'',
            iconType:'.svg',
            singleSelect:true,
            isOpen:false,
            default:'featured'
        },
        {
            name:'price',
            label:'Price',
            urlLabel:'Price',
            type:'slider', 
            displaySelected:true, 
            singleSelect:true,
            default:null,
            isOpen:false,
            config:{step:1, type: 'num', format:{notation:'$', position:'prepend'}}
        },
    ]
    

    const results = computed(() => store.getSettingListingResult())
    
   
    const resultCount = computed(() => store.getSettingListingResultCount())


    const showSkeleton = computed(()=>store.getSettingShowSkeleton() )


    const getSettingListingNextPageUrl = computed(() => store.getSettingListingNextPageUrl())
   

    // console.log('getSettingListingNextPageUrl', getSettingListingNextPageUrl.value, process)

    const displayNoResults = computed(() => {
        return store.getSettingListingCurrentPage() === 1 && results.value.length === 0
    })

    const hasError = computed(() => {
        return store.getListingError()
    })

    const showMoreSkeleton = computed(() => {
        return store.getSkeletonShowMore()
    })

    function showMore(){
        store.toggleSettingListingShowMore({ type: moduleSubType})
    }

    if (['pendant', 'earring'].includes(moduleSubType)) {
        fAttributes.splice(1,1)
    }



    function changeViewType(type){
        viewType.value = type
    }

 

    const settings = { moduleType:moduleType, moduleSubType:moduleSubType, filters : fAttributes, page:'setting' }


    onMounted(() =>{
        $choosesettingGtag(moduleSubType);

        store.validateCyoSettingCase({ moduleSubType:moduleSubType, filters : fAttributes, page : 'setting' } )  

    })


    const openQuickView = (data)=>{
        document.body.classList.add('filter_open');
        quickViewProduct.value = data
        nextTick(()=>{
            openQuickSettingView.value = true
        })
    }
    
    const closeQuickView = ()=>{
        document.body.classList.remove('filter_open');
        openQuickSettingView.value = false
        // setTimeout(()=>{
        //     quickViewProduct.value = null
        // },500)   
    }

    

    // start
    const initialPageCallback = async ( asyncData ) => {

        
        if( asyncData  ){

            return await Promise.all( [
                tags.setMetaTags(),
                useAsyncData( route.fullPath , () => store.setupCyoSettingFilter(settings, route, router).then( () => true ).catch( (error)=> console.log('error', error) ))
            ])
        
        }else{

            return await Promise.all( [
                tags.setMetaTags(),
                store.setupCyoSettingFilter(settings, route, router).then( () => true )
            ])
        }

    }

    if( import.meta.client ){
        
        // Make RefreshKey reactive using computed
        const refreshKey = computed(() => route.params.start_with);
        // watch works directly on a ref
        watch(refreshKey, async (nv, ov) => {
            if( typeof nv == 'string'  ){
                initialPageCallback()
            }
        })
    }
    
    const isHydratedOnServer =  (import.meta.client && nuxtApp.isHydrating && nuxtApp.payload.serverRendered)

    // reset the store on client side page navigations
    if( !isHydratedOnServer ) {

        await store.$reset()
    }   


    usePopstateHandler(async () => {
        initialPageCallback(false)
    });

    if( import.meta.client ){

        initialPageCallback(true)
    }else{

        await initialPageCallback( true)
    }
    // end

</script>

<style scoped>
   
    .min_height{
        min-height: 60vh;
    }
    .spinner{
        height: 45vh; 
    }

    .loader_box {
        /* height: 30vh; */
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .loader_box_mod {
        /* height: 30vh; */
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .blur-effect {
      filter: blur(0);
      transition: filter 0.1s;
    }

    .blur-effect.blur {
      filter: blur(5px);
    }
    .more_data_box {
        width: fit-content;
    }

    .show_more_btn {
        border: 1px solid #000;
        border-radius: 4px;
        letter-spacing: 1.4px;
        font-size: 14px;
        font-weight: 600;
        margin: 0 auto;
        padding: 11px 25px;
        text-transform: uppercase;
        width: 100%;
        cursor: pointer;
    }

</style>